import { stateStatusType, DcddUserProps, DcddUserProfileProps, GenericProps } from './actionType';

export interface FetchDcddUsersState {
    isLoading: boolean;
    error: string | null;
    dcddUsers: DcddUserProps[] | [];
    dcddActiveUsers: DcddUserProps[] | [];
    filteredDcddUser: DcddUserProps[] | [];
    fetchDzongkhag: GenericProps[] | [];
    fetchSchool: GenericProps[] | [];
    fetchEcdd: GenericProps[] | [];
    fetchGrade: GenericProps[] | [];
    status: stateStatusType | null;
    delete: string | null;
}
export interface FetchDcddUserProfileState {
    isLoading: boolean;
    error: string | null;
    dcddUserProfile: DcddUserProfileProps | null;
    dcddUserStatus: DcddUserProps | null;
    status: stateStatusType | null;
    delete: string | null;
}
export interface GenericDcddUsersState {
    isLoading: boolean;
    error: string | null;
    status: stateStatusType | null;
}
export const initalDcddUsersState: FetchDcddUsersState = {
    isLoading: false,
    error: null,
    dcddUsers: [],
    filteredDcddUser: [],
    fetchDzongkhag: [],
    fetchSchool: [],
    fetchEcdd: [],
    fetchGrade: [],
    dcddActiveUsers: [],
    status: null,
    delete: null,
};
export const initalDcddUserProfileState: FetchDcddUserProfileState = {
    isLoading: false,
    error: null,
    dcddUserProfile: null,
    dcddUserStatus: null,
    status: null,
    delete: null,
};
export const initalGenericDcddUsersState: GenericDcddUsersState = {
    isLoading: false,
    error: null,
    status: null,
};
export interface DcddUsers {
    dcddUserState: FetchDcddUsersState;
    dcddUserProfileState: FetchDcddUserProfileState;
    genericDcddUserState: GenericDcddUsersState;
}

export const initialState: DcddUsers = {
    dcddUserState: initalDcddUsersState,
    dcddUserProfileState: initalDcddUserProfileState,
    genericDcddUserState: initalGenericDcddUsersState
};


